import request from '@/libs/request'

// 商品列表
export function goodsListApi (data) {
  return request({
    url: `goods/list`,
    method: 'get',
    params: data
  })
}

// 详情分类
export function goodsCate () {
  return request({
    url: `goods/getCate`,
    method: 'get'
  })
}

// 商品添加/编辑
export function goodsSaveApi (data) {
  return request({
    url: `goods/save`,
    method: 'post',
    data: data
  })
}

// 商品详情
export function goodsInfoApi (id) {
  return request({
    url: `goods/info/${id}`,
    method: 'get'
  })
}

// 商品删除
export function goodsDelApi (id) {
  return request({
    url: `goods/delete/${id}`,
    method: 'delete'
  })
}

// 修改商品状态
export function changeGoodsStatusApi (id) {
  return request({
    url: `goods/changeStatus/${id}`,
    method: 'post'
  })
}

export function getAgentLevel () {
  return request({
    url: `goods/getAgentLevel`,
    method: 'get'
  })
}
export function getRegion () {
  return request({
    url: `goods/getRegion`,
    method: 'get'
  })
}
export function shen (data) {
  return request({
    url: `goods/shen`,
    method: 'post',
    data
  })
}
export function getManagerCate () {
  return request({
    url: `goods/getManagerCate`,
    method: 'get'
  })
}
// 导出
export function exportlistapi (params) {
  return request({
    url: `goods/export`,
    method: 'get',
    params
  })
}

// 导出
export function exportShoplistapi (params) {
  return request({
    url: `goods/exportShop`,
    method: 'get',
    params
  })
}
// 导入
export function importlist (data) {
  return request({
    url: `goods/import`,
    method: 'post',
    data
  })
}
export function getshops () {
  return request({
    url: `shop/getall`,
    method: 'get'
  })
}
export function recommand (data) {
  return request({
    url: `goods/isRecommand`,
    method: 'post',
    data
  })
}

export function recommandInfo (id) {
  return request({
    url: `goods/recommandInfo/${id}`,
    method: 'get'
  })
}



// 修改商品溯源推荐状态
export function changeGoodsTraceabilityRecommendation (id) {
  return request({
    url: `goods/changeGoodsTraceabilityRecommendation/${id}`,
    method: 'post',
  })
}

// 获取商品二维码
export function generateGoodsQrcodeApi(id) {
  return request({
    url: `goods/generateGoodsQrcode/${id}`,
    method: 'get',
    responseType: 'blob',
  })
}

// 获取店铺基地商品库存
export function getShopInventoryApi(shopId) {
  return request({
    url: `goods/getShopInventory`,
    method: 'get',
    params: {
      shop_id: shopId
    }
  })
}

// 获取店铺基地加工销售记录
export function getShopProductionSaleApi(shopId) {
  return request({
    url: `goods/getShopProductionSale`,
    method: 'get',
    params: {
      shop_id: shopId
    }
  })
}
